import React from 'react';
import type { BlockMethod } from 'types/block-method';

import Image from 'next/image';

import { Paragraph, Wrap } from '@leafwell/components';
import Figure from './figure';
import HeadingBody from './heading-body';

import { useWordPressContext } from 'contexts/wordpress-provider';

const Method: React.FC<BlockMethod> = ({
  sectionId,
  title,
  incomes,
  outcomes,
}) => {
  const { translations } = useWordPressContext();

  return (
    <Wrap id={sectionId} size="large" className="justify-items-center !gap-y-8">
      <HeadingBody
        className="text-center"
        level="2"
        title={title}
        tagName="h2"
      />
      {incomes?.length > 0 ? (
        <ul className="relative flex flex-col md:flex-row flex-wrap justify-center items-center	max-w-3xl gap-4 border-2 rounded-lg border-lilac-300 border-dotted p-10 mt-4">
          {incomes.map(({ income }, idx) => {
            return (
              <li
                key={`income-${idx}`}
                className="inline-flex items-center font-medium rounded-3xl select-none py-1 px-4 border-2 border-lilac-300 bg-lilac-50 text-black w-fit"
              >
                {income}
              </li>
            );
          })}
          <Image
            src="/logo-full.jpg"
            alt=""
            className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2"
            loading="lazy"
            width={187}
            height={26}
          />
        </ul>
      ) : null}
      <Image
        src="/arrow-vertical.svg"
        alt=""
        className=""
        loading="lazy"
        width={24}
        height={47}
      />
      <Paragraph className="text-3xl sm:text-5xl">
        {translations['Outcomes']}
      </Paragraph>
      {outcomes?.length > 0 ? (
        <ol className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 xl:gap-5">
          {outcomes.map(({ outcome, icon }, idx) => {
            return (
              <li
                key={`outcome-${idx}`}
                className="grid justify-items-center gap-6 p-5 border-2 rounded-lg border-lilac-300 border-dotted"
              >
                <Paragraph
                  size="small"
                  className="text-center inline-grid items-center w-7 h-7 rounded-full bg-lilac-50 justify-self-start"
                >
                  {idx + 1}
                </Paragraph>
                <Figure {...icon} />
                <Paragraph className="text-center">{outcome}</Paragraph>
              </li>
            );
          })}
        </ol>
      ) : null}
    </Wrap>
  );
};

export default Method;
